
function track(category, action, label) {
	if(typeof window.trackEvent !== 'undefined') {
		window.trackEvent(category, action, label)
	}
}


export default track


/** WEBPACK FOOTER **
 ** ./main/assets/article/js/src/window-ga.js
 **/